import React, { Component } from "react";
import styled from "styled-components";
import axios from "axios";
import ReactTable from "react-table";
import { API_URL, DOWNLOAD_URL } from "../constants";
import {
  PageWrapper,
  FlexWrapper,
  SelectBox,
  Checkbox,
  Button,
  Modal,
  XMText,
  Header
} from "../components";
import "react-table/react-table.css";
import { isEmpty, get } from "lodash";
import { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
  // position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
    margin-top: 60px;
    // position: fixed;
    // width:97%;
  }
  .rt-td {
    white-space: normal !important;
  }
  .rt-tbody {
    padding-top: 50px;
    height:500px;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* min-width: 650px !important; */
    /* max-height: calc(100vh - 93px); */
  }
`;

// const TableWrap = styled.div`
 
// `;
const ImageWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  & > a {
    display: block;
    width: calc(33.33% - 20px);
    margin: 0 10px;
    & > img {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }
  }
`;

const ReceiptWrapper = styled.div`
  width: 100%;
  padding: 20px 10px;
  & > h4 {
    font-size: 16px;
    padding-bottom: 10px;
    color: #212121;
    margin-bottom: 10px;
    border-bottom: 1px solid #dcdcdc;
  }
`;
const ProductWrapper = styled.div`
  width: 100%;
  padding: 20px 10px;
  & > h4 {
    font-size: 16px;
    padding-bottom: 10px;
    color: #212121;
    margin-bottom: 10px;
    border-bottom: 1px solid #dcdcdc;
  }
`;

class ViewPurchasedProducts extends Component {
  state = {
    showModal: false,
    loader: false,
    userReceiptProductsData: [],
    selectedOption: null,
    checked: false,
    checkedRows: [],
    checkAll: false,
    changeStatusModal: false,
    isSubmitLoading: false
  };

  componentDidMount() {
    this.getUserReceiptProducts();
  }

  getUserReceiptProducts = async () => {
    /*  const query = {
      filter: {
        where: {
          userReceiptId: get(this.props.match, 'params.id', '')
        },
        include: ['userReceipt']
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserReceiptProducts`, { params: { filter: query.filter } })
      this.setState({ userReceiptProductsData: data })
    } catch (error) {
      console.log(error)
    } */

    const query = {
      filter: {
        include: ["userReceiptProduct"]
      }
    };
    try {
      const { data } = await axios.get(
        `${API_URL}/userReceipts/${get(this.props.match, "params.id", "")}`,
        {
          params: { filter: query.filter }
        }
      );
      this.setState({ userReceiptProductsData: data });
      console.log("data", data);
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = selectedOption => {
    this.setState({ selectedOption: selectedOption });
  };

  submitStatus = async () => {
    this.setState({ isSubmitLoading: true });
    try {
      await axios.post(`${API_URL}/UserReceiptProducts/bulk-approve`, {
        data: {
          ids: this.state.checkedRows,
          status: get(this.state.selectedOption, "value", "")
        }
      });
      const userReceiptId = get(this.state.userReceiptProductsData, "id", "");
      await axios.post(
        `${API_URL}/UserReceipts/calculateReferral/${userReceiptId}`
      );
      if (get(this.state.selectedOption, "value", "") === "Approved") {
        const q = {
          filter: {
            where: {
              referralType: "Purchase",
              referralDescription: userReceiptId
            }
          }
        };
        const { data: referral } = await axios.get(`${API_URL}/Referrals`, {
          params: { filter: q.filter }
        });
        if (get(referral, "0.status", "") === "Pending") {
          await axios.patch(
            `${API_URL}/Referrals/${get(referral, "0.id", "")}`,
            {
              status: "Approved"
            }
          );
        }
      }
      this.setState({
        isSubmitLoading: false,
        changeStatusModal: false,
        checkedRows: [],
        checkAll: false
      });
      this.getUserReceiptProducts();
    } catch (error) {
      this.setState({ isSubmitLoading: false });
      console.log(error);
    }
  };

  checkRow(itemId, checked) {
    if (checked) {
      this.setState({ checkedRows: [...this.state.checkedRows, itemId] });
    } else {
      this.setState({
        checkedRows: this.state.checkedRows.filter(id => id !== itemId),
        checkAll: false
      });
    }
  }

  getGsPoints(greenScore,modifiedPrice) {
    console.log(greenScore,modifiedPrice)
    let productGsPoints = 0;
      productGsPoints =
        productGsPoints +
        (((modifiedPrice || 0) * greenScore) /
          ((100 / greenScore) * 1200)) *
          100;
    return Math.round(productGsPoints);
  };

  checkAll(checked) {
    if (checked) {
      this.setState({
        checkAll: true,
        checkedRows: get(
          this.state.userReceiptProductsData,
          "userReceiptProduct",
          []
        ).map(item => item.id)
      });
    } else {
      this.setState({
        checkedRows: [],
        checkAll: false
      });
    }
  }

  render() {
    const {
      userReceiptProductsData,
      selectedOption,
      changeStatusModal,
      isSubmitLoading,
      showModal
    } = this.state;
    // console.log('Option selected:', selectedOption)
    const imgs = get(userReceiptProductsData, "image", "[]");
    const newImages = imgs === "" ? [] : JSON.parse(imgs);
    const productImages = get(userReceiptProductsData, "productImages", "[]"); 
    let newProductImages = productImages === "" ? [] : JSON.parse(productImages);
    newProductImages = newProductImages === null ? [] : newProductImages;
    return (
      <React.Fragment>
        <GlobalStyle />
        <Header
          icon="arrowBack"
          title="View Purchased Products"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          style={{ minWidth: "100%" }}
          color="#fff"
        />
        {/* <PageWrapper
          viewPadding="0 20px"
          height="300px"
          modifyPadding="0 20px"
          style={{ marginTop: 60 }}
        > */}
          {/* <TableWrap> */}
            <ReactTable
              data={get(userReceiptProductsData, "userReceiptProduct", [])}
              sortable={false}
              columns={[
                {
                  Header: row => (
                    <FlexWrapper alignItems="center">
                      <React.Fragment>
                        <XMText color="#fff">ID</XMText>
                        <XMText
                          color="#fff"
                          onClick={() => this.setState({ showModal: true })}
                          style={{ textDecoration: "underline" }}
                        >
                          View Bill(s)
                        </XMText>
                      </React.Fragment>
                    </FlexWrapper>
                  ),
                  accessor: "id",
                  width: 100
                },
                {
                  Header: "List Name",
                  accessor: "listName",
                  Cell: row => get(row.original, "listName", ""),
                  width: 150
                },
                {
                  Header: row => {
                    return (
                      <React.Fragment>
                        <div>
                          Current Status
                          <Checkbox
                            flip
                            label="Check All"
                            checked={this.state.checkAll}
                            onChange={checked => this.checkAll(checked)}
                            borderColor="#fff"
                          />
                        </div>
                        {this.state.checkedRows.length > 0 ? (
                          <div
                            style={{
                              border: "1px solid #fff",
                              borderRadius: 6,
                              padding: 5,
                              marginTop: 4
                            }}
                            onClick={() =>
                              this.setState({ changeStatusModal: true })
                            }
                          >
                            {this.state.checkedRows.length > 0 && (
                              <span>Change Status</span>
                            )}
                          </div>
                        ) : null}
                      </React.Fragment>
                    );
                  },
                  accessor: "status",
                  Cell: row => (
                    <React.Fragment>
                      <Checkbox
                        flip
                        label={get(row, "original.status", "")}
                        circle={false}
                        checked={
                          this.state.checkedRows.indexOf(
                            get(row.original, "id", 0)
                          ) > -1
                        }
                        onChange={checked =>
                          this.checkRow(get(row.original, "id", 0), checked)
                        }
                      />
                    </React.Fragment>
                  ),
                  minWidth: 200
                },
                {
                  Header: "Product Code",
                  accessor: "productCode",
                  width: 200
                },
                {
                  Header: "Receipt Product Name",
                  accessor: "storeProductName",
                  Cell: row => get(row.original, "storeProductName", ""),
                  width: 200
                },
                {
                  Header: "Product Name",
                  accessor: "productName",
                  Cell: row => get(row.original, "productName", ""),
                  width: 150
                },
                {
                  Header: "Product Category",
                  accessor: "productCategory",
                  Cell: row => get(row.original, "productCategory", ""),
                  width: 150
                },
                {
                  Header: "Store Name",
                  accessor: "storeName",
                  Cell: row => get(row.original, "storeName", ""),
                  width: 150
                },
                {
                  Header: "Total Gs Points",
                  Cell: row =>
                    this.getGsPoints(
                      get(row.original, "greenScore", []), get(row.original, "modifiedPrice", [])
                    ),
                  width: 200
                },
                {
                  Header: "Product Image",
                  accessor: "productImage",
                  Cell: row =>
                    isEmpty(get(row.original, "productImage", "")) ? (
                      <img
                        src={require("../static/images/no-image.png")}
                        height="100px"
                        alt={"demo"}
                      />
                    ) : (
                      <img
                        src={get(row.original, "productImage", "")}
                        height="100px"
                        alt={get(row.original, "productName", "")}
                      />
                    ),
                  width: 150
                },
                {
                  Header: "Green Score",
                  accessor: "greenScore",
                  Cell: row => Math.round(get(row.original, "greenScore", "")),
                  width: 100
                },
                {
                  Header: "Quantity",
                  accessor: "quantity",
                  width: 100
                },
                {
                  Header: "Unit",
                  accessor: "quantityUnit",
                  width: 100
                },
                {
                  Header: "Original Price",
                  accessor: "originalPrice",
                  Cell: row =>
                    get(row.original, "originalPrice", 0)
                      ? `$${get(row.original, "originalPrice", 0).toFixed(2)}`
                      : "$0",
                  width: 100
                },
                {
                  Header: "Modified Price",
                  accessor: "modifiedPrice",
                  Cell: row =>
                    get(row.original, "modifiedPrice", 0)
                      ? `$${get(row.original, "modifiedPrice", 0).toFixed(2)}`
                      : "$0",
                  width: 100
                },
                {
                  Header: (
                    <FlexWrapper alignItems="center">
                      <XMText color="#fff">Action</XMText>
                      <span
                        style={{ color: "#fff", textDecoration: "underline" }}
                        onClick={() =>
                          this.props.history.push({
                            pathname: `/add-purchased-products-native/${get(
                              userReceiptProductsData,
                              "id",
                              ""
                            )}/${get(userReceiptProductsData, "userId", "")}`,
                            state: {
                              listName: get(
                                userReceiptProductsData,
                                "userReceiptProduct.0.listName",
                                ""
                              ),
                              zipCode: get(
                                userReceiptProductsData,
                                "userReceiptProduct.0.zipCode",
                                ""
                              )
                            }
                          })
                        }
                      >
                        {" "}
                        Add Products
                      </span>
                    </FlexWrapper>
                  ),
                  Cell: row => (
                    <React.Fragment>
                      <Link
                        style={{
                          color: "#124b5f",
                          textDecoration: "underline"
                        }}
                        to={`/edit-purchased-products-native/${get(
                          row.original,
                          "id",
                          ""
                        )}`}
                      >
                        Edit Product
                      </Link>
                    </React.Fragment>
                  ),
                  width: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={true}
              className="-striped -highlight"
            />
          {/* </TableWrap> */}
        {/* </PageWrapper> */}
        <Modal
          title={"Change status"}
          show={changeStatusModal}
          hide={!changeStatusModal}
          style={{ minHeight: 240 }}
          onClose={() => this.setState({ changeStatusModal: false })}
        >
          <FlexWrapper alignItems="center">
            <SelectBox
              name="status"
              options={[
                { value: "Pending", label: "Pending" },
                { value: "Approved", label: "Approved" },
                { value: "Reject", label: "Reject" }
              ]}
              value={selectedOption}
              onChange={this.handleChange}
              selectField
            />
            <Button
              size="small"
              label="Submit"
              volume="filled"
              margin="14px 0 0 0"
              type="submit"
              isLoading={isSubmitLoading}
              disabled={isSubmitLoading}
              onClick={this.submitStatus}
            />
          </FlexWrapper>
        </Modal>
        <Modal
          title={"Bills"}
          show={showModal}
          hide={!showModal}
          style={{ minHeight: 400 }}
          maxWidth="800px"
          onClose={() => this.setState({ showModal: false })}
        >
          <ReceiptWrapper>
            <h4>Receipt Images</h4>
            <React.Fragment>
              <ImageWrap>
                {newImages.map(item => {
                  return (
                    <a href={`${DOWNLOAD_URL}/${item}`} target="_blank">
                      <img
                        src={`${DOWNLOAD_URL}/${item}`}
                        height="100px"
                        width="100px"
                        objectFit="cover"
                      />
                    </a>
                  );
                })}
              </ImageWrap>
            </React.Fragment>
          </ReceiptWrapper>
          <ProductWrapper>
            <h4>Products Images</h4>
            <React.Fragment>
              <ImageWrap>
                {newProductImages.map(item => {
                  return (
                    <a href={`${DOWNLOAD_URL}/${item}`} target="_blank">
                      <img
                        src={`${DOWNLOAD_URL}/${item}`}
                        height="100px"
                        width="100px"
                        objectFit="cover"
                      />
                    </a>
                  );
                })}
              </ImageWrap>
            </React.Fragment>
          </ProductWrapper>
        </Modal>
      </React.Fragment>
    );
  }
}
export default ViewPurchasedProducts;



// WEBPACK FOOTER //
// ./src/pages/ViewPurchasedProducts.js